module.exports = __webpack_public_path__ + "media/theme/tag-off-right-bg-545023d1.png";